export const GET_CHATMETER_SSO_TOKEN = "GET_CHATMETER_SSO_TOKEN";
export const GET_CHATMETER_SSO_TOKEN_SUCCESS = "GET_CHATMETER_SSO_TOKEN_SUCCESS";
export const GET_CHATMETER_SSO_TOKEN_ERROR = "GET_CHATMETER_SSO_TOKEN_ERROR";
export const SHOW_INFO_HEADER = "SHOW_INFO_HEADER";